import { createContext } from 'react'
import { Manager } from 'socket.io-client'

export interface ISocketContext {
  socketManager: Manager
}

export const SocketContext = createContext<ISocketContext>({
  socketManager: {} as Manager,
})
